import React from "react";

const WebBookingIcon = ({
  size = 24,
  color = "#222222",
  className = "",
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M8 0C12.4 0 16 3.6 16 8C16 12.4333 12.4 16 8 16C3.56667 16 0 12.4333 0 8C0 3.6 3.56667 0 8 0ZM13.5333 4.8C12.9333 3.8 12.0667 2.93333 11 2.36667C11.3667 3.06667 11.6667 3.9 11.9 4.8H13.5333ZM10.6667 8C10.6667 7.46667 10.6 6.93333 10.5333 6.4H5.43333C5.36667 6.93333 5.33333 7.46667 5.33333 8C5.33333 8.56667 5.36667 9.1 5.43333 9.6H10.5333C10.6 9.1 10.6667 8.56667 10.6667 8ZM8 14.4C8.7 14.4 9.66667 13.2 10.2333 11.2H5.73333C6.3 13.2 7.26667 14.4 8 14.4ZM5.73333 4.8H10.2333C9.66667 2.83333 8.7 1.6 8 1.6C7.26667 1.6 6.3 2.83333 5.73333 4.8ZM4.96667 2.36667C3.9 2.93333 3.03333 3.8 2.43333 4.8H4.06667C4.3 3.9 4.6 3.06667 4.96667 2.36667ZM1.8 6.4C1.66667 6.93333 1.6 7.46667 1.6 8C1.6 8.56667 1.66667 9.1 1.8 9.6H3.8C3.73333 9.1 3.73333 8.56667 3.73333 8C3.73333 7.46667 3.73333 6.93333 3.8 6.4H1.8ZM2.43333 11.2C3.03333 12.2333 3.9 13.1 4.96667 13.6667C4.6 12.9667 4.3 12.1333 4.06667 11.2H2.43333ZM11 13.6667C12.0667 13.1 12.9333 12.2333 13.5333 11.2H11.9C11.6667 12.1333 11.3667 12.9667 11 13.6667ZM14.1667 9.6C14.3 9.1 14.4 8.56667 14.4 8C14.4 7.46667 14.3 6.93333 14.1667 6.4H12.1667C12.2333 6.93333 12.2667 7.46667 12.2667 8C12.2667 8.56667 12.2333 9.1 12.1667 9.6H14.1667Z"
        fill={color}
      />
    </svg>
  );
};

export default WebBookingIcon;
